import Cookie from 'universal-cookie'

/**
 * For appending new auth header for toggle-able seamless auth
 */
let enableSeamlessAuth = false
const cookie = new Cookie()

/**
 * Set from clients_config/config API
 * @param {boolean} enable
 */
export const setEnableSeamlessAuth = (enable) => {
  enableSeamlessAuth = enable
}

export const getEnableSeamlessAuth = () => {
  return enableSeamlessAuth
}

export const processAuthHeaders = (argHeaders) => {
  const config = {}
  if (enableSeamlessAuth) {
    const token = cookie.get('chat_sso_token')
    if (token) {
      const _token = token.replace('bearer ', '')
      config['X-Auth-Token'] = _token
    }
    Object.assign(argHeaders, config)
  }
  return config
}

export const processCrmAuthHeaders = (argHeaders) => {
  const config = {}
  if (enableSeamlessAuth) {
    const token = cookie.get('crm_sso_token')
    if (token) {
      const _token = token.replace('bearer ', '')
      config['X-Auth-Token'] = _token
    }
    Object.assign(argHeaders, config)
  }
  return config
}
